import React from "react";
import { SimahVerificationResult } from "../types";
import { COLORS } from "../constants";
import { formatValue } from "../hook/API";

/* =======================
   PROPS
======================= */

type Props = {
  data?: SimahVerificationResult;
};

/* =======================
   FIELD CONFIG
======================= */

type FieldConfig = {
  label: string;
  key: keyof SimahVerificationResult;
};

const SIMAH_FIELDS: FieldConfig[] = [
  // SIMAH Core
  { label: "SIMAH Check Valid", key: "SimahCheckValid" },
  { label: "SIMAH Score", key: "SimahScore" },
  { label: "High Risk Flag", key: "Bkp1forHightRisk" },
  { label: "Default Amount", key: "DefaultAmount" },

  // Bureau Count
  { label: "Bureau Count", key: "BC_Count" },
  { label: "BC Last 60 Months", key: "BC_Last60Month" },
  { label: "BC Last Load Date", key: "BC_LastLoadDate" },
  { label: "Months Since BC Load", key: "BC_MonthSinceLastLoad" },

  // Defaults (DF)
  { label: "Default Count", key: "DF_Count" },
  { label: "Default Loan", key: "DF_Loan" },
  { label: "Last Settlement Date", key: "DF_LastSettldDate" },
  { label: "Months Since Last Settlement", key: "DF_MonthSinceLastSettld" },

  // Delinquencies (DLQ)
  { label: "DLQ – Last 3 Months", key: "DLQ_Last3Months" },
  { label: "DLQ – Last 6 Months", key: "DLQ_Last6Months" },
  { label: "DLQ – Last 12 Months", key: "DLQ_Last12Months" },
  { label: "DLQC Closed Loan", key: "DLQC_ClosedLoan" },

  // Judgements (JDG)
  { label: "Judgement Count", key: "JDG_Count" },
  { label: "Pending Judgements", key: "JDG_CountPending" },
  { label: "Court Order (Last 12 Months)", key: "JDG_Last12MonthCourtOrder" },
  { label: "Court Order (Last 36 Months)", key: "JDG_Last36MonthCourtOrder" },
  { label: "Court Order (Last 120 Months)", key: "JDG_Last120MonthPendingCourtOrder" },
  { label: "Judgement Last Settled Date", key: "JDG_LastSettldDate" },
  { label: "Months Since Judgement Settled", key: "JDG_MonthSinceLastSettld" },
  { label: "Pending Case Date", key: "JDG_PendingLastCaseDate" },
  { label: "Months Since Pending Case", key: "JDG_PendingMonthSinceLastCase" },
];


/* =======================
   COMPONENT
======================= */

const SimahVerificationResultView: React.FC<Props> = ({ data }) => {

  return (
    <div style={{ overflowX: "auto", marginTop: 20 }}>
      <table className="table text-left table-border spaced-table">
        <thead style={{ background: "#F8F8F8" }}>
          <tr style={{ color: COLORS.TEXT_MUTED }}>
            <th>Field</th>
            <th>Value</th>
          </tr>
        </thead>

        <tbody style={{ color: COLORS.TEXT_MUTED, fontSize: "small" }}>
          {SIMAH_FIELDS.map(({ label, key }) => (
            <tr key={key}>
              <td>{label}</td>
              <td>{formatValue(data?.[key])}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default SimahVerificationResultView;
